export const AUTH_KEYCLOAK_INIT = "AUTH_KEYCLOAK_INIT";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
